

export default function Settings() {

    return (
        <>
            Settings
        </>
    )
}